import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { InputFilters } from './InputFilters';
export function Filters({ handleInputValueChange, isSubmitting, setFieldValue, inputValues }) {
    return (_jsx(_Fragment, { children: _jsx(InputFilters, { handleInputValueChange: handleInputValueChange, inputValues: inputValues, isSubmitting: isSubmitting, setFieldValue: setFieldValue }) }));
}
